const isDev = process.env.NODE_ENV === 'development';

const ts = () => new Date().toISOString();

const logger = {
  info:  (msg: string, ...args: unknown[]) => isDev && console.info( `[INFO]  ${ts()} ${msg}`, ...args),
  warn:  (msg: string, ...args: unknown[]) => isDev && console.warn( `[WARN]  ${ts()} ${msg}`, ...args),
  error: (msg: string, ...args: unknown[]) => console.error(`[ERROR] ${ts()} ${msg}`, ...args),
  debug: (msg: string, ...args: unknown[]) => isDev && console.debug(`[DEBUG] ${ts()} ${msg}`, ...args),
};

export default logger;
